export const transformOSNameToOSType = (os: string): string | null => {
  if (!os) {
    return null;
  }
  const OSLowerCase = os.toLowerCase();
  if (OSLowerCase.indexOf('windows') > -1) {
    return 'Windows';
  }
  if (OSLowerCase.indexOf('mac') > -1) {
    return 'Mac';
  }
  if (OSLowerCase.indexOf('linux') > -1) {
    return 'Linux';
  }
  if (OSLowerCase.indexOf('ubuntu') > -1) {
    return 'Ubuntu';
  }
  if (OSLowerCase.indexOf('android') > -1) {
    return 'Android';
  }
  if (OSLowerCase.indexOf('ios') > -1) {
    return 'iOS';
  }
  return null;
};
